<div [@routerTransition]>
    <sub-header [title]="'StockTakes' | localize" [description]="'StockTakeseaderInfo' | localize">
        <div role="actions">
            <button
                id="btn_create_StockTake"
                *ngIf="'Pages.StockTake.Create' | permission"
                (click)="createStockTake()"
                class="btn btn-primary blue"
            >
                <i class="fa fa-plus"></i>
                {{ l('CreateNewStockTake') }}
            </button>
        </div>
    </sub-header>

    <div [class]="containerClass">
        <div class="card card-custom gutter-b">
            <div class="card-body">
                <form class="form" autocomplete="off">
                    <div>
                        <div class="row align-items-center">
                            <div class="col-xl-12">
                                <div class="my-3">
                                    <div class="input-group mb-3">
                                        <input
                                            [(ngModel)]="filterText"
                                            (ngModelChange)="getStockTakes()"
                                            name="filterText"
                                            autoFocus
                                            type="text"
                                            class="form-control"
                                            [placeholder]="l('SearchWithThreeDot')"
                                        />
                                        <button class="btn btn-primary" type="submit" (click)="getStockTakes()">
                                            <i class="flaticon-search-1"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row" [hidden]="!advancedFiltersAreShown">
                            <div class="col-md-12"></div>

                            <div class="col-md-12 mt-5">
                                <button
                                    (click)="resetFilters()"
                                    class="btn btn-secondary btn-sm"
                                    id="btn-reset-filters"
                                >
                                    Reset
                                </button>
                            </div>
                        </div>
                    </div>
                </form>

                <div class="row align-items-center">
                    <!--<Primeng-Datatable-Start>-->
                    <div class="primeng-datatable-container col-12" [busyIf]="primengTableHelper.isLoading">
                        <p-table
                            #dataTable
                            (onLazyLoad)="getStockTakes($event)"
                            [value]="primengTableHelper.records"
                            rows="{{ primengTableHelper.defaultRecordsCountPerPage }}"
                            [paginator]="false"
                            tableStyleClass="table table-bordered table-hover"
                            [lazy]="true"
                            [scrollable]="true"
                            ScrollWidth="100%"
                            [tableStyle]="{ 'min-width': '50rem' }"
                            [resizableColumns]="primengTableHelper.resizableColumns"
                        >
                            <ng-template pTemplate="header">
                                <tr>
                                    <th style="width: 5%"
                                        [hidden]="!isGrantedAny('Pages.StockTakes.Edit', 'Pages.StockTake.Delete')">
                                        {{ l('Actions') }}
                                    </th>
                                    <th style="width: 150px" pSortableColumn="StockTakeNo">
                                        {{ l('StockTakeNo') }}
                                        <p-sortIcon field="StockTake.stockTakeNo"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="StockTakeDate">
                                        {{ l('StockTakeDate') }}
                                        <p-sortIcon field="StockTake.stockTakeDate"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="name">
                                        {{ l('Name') }}
                                        <p-sortIcon field="StockTake.stockTakeName"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="name">
                                        {{ l('Remarks') }}
                                        <p-sortIcon field="StockTake.stockTakeName"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="status">
                                        {{ l('Status') }}
                                        <p-sortIcon field="StockTake.status"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="TotalPhysicalQty">
                                        {{ l('Qty') }}
                                        <p-sortIcon field="StockTake.totalPhysicalQty"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="TotalVarianceQty">
                                        {{ l('VarianceQty') }}
                                        <p-sortIcon field="StockTake.totalVarianceQty"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="CreationTime">
                                        {{ l('CreationTime') }}
                                        <p-sortIcon field="StockTake.creationTime"></p-sortIcon>
                                    </th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-record="$implicit" let-i="rowIndex">
                                <tr>
                                    <td style="width: 5%"
                                        [hidden]="!isGrantedAny('Pages.StockTakes.Edit', 'Pages.StockTake.Delete')">
                                        <div class="btn-group dropdown" dropdown container="body">
                                            <button class="dropdown-toggle btn btn-sm btn-primary" dropdownToggle>
                                                <i class="fa fa-cog"></i>
                                                <span class="caret"></span>
                                            </button>
                                            <ul class="dropdown-menu" *dropdownMenu>
                                                <li>
                                                    <a href="javascript:;"
                                                       *ngIf="permission.isGranted('Pages.StockTake.Edit')"
                                                       class="dropdown-item"
                                                       (click)="createOrEditStockTakeModal.show(record.stockTake.id)">
                                                        {{ l('Edit') }}
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="javascript:;"
                                                       *ngIf="record.stockTake.status == status.Processed"
                                                       class="dropdown-item"
                                                       [routerLink]="['/app/stock/stocktakes/addstockitem',]"
                                                       [queryParams]="{ id: record.stockTake.id }">
                                                        {{ l('View') }}
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="javascript:;"
                                                       *ngIf="record.stockTake.status == status.Draft"
                                                       class="dropdown-item"
                                                       [routerLink]="['/app/stock/stocktakes/addstockitem',]"
                                                       [queryParams]="{ id: record.stockTake.id }">
                                                        {{ l('AddStock') }}
                                                    </a>
                                                </li>
                                                <li>
                                                    <a class="dropdown-item"
                                                       href="javascript:;"
                                                       *ngIf="record.stockTake.status == status.Draft"
                                                       (click)="updateStock(record.stockTake)">
                                                        {{ l('UpdateStock') }}
                                                    </a>
                                                </li>
                                                <li>
                                                    <a class="dropdown-item"
                                                       href="javascript:;"
                                                       *ngIf="record.stockTake.status == status.Draft"
                                                       (click)="updateFullStock(record.stockTake)">
                                                        {{ l('UpdateAllStock') }}
                                                    </a>
                                                </li>
                                                <li>
                                                    <a class="dropdown-item"
                                                       href="javascript:;"
                                                       *ngIf="permission.isGranted('Pages.StockTake.Delete')"
                                                       (click)="deleteStockTake(record.stockTake)">
                                                        {{ l('Delete') }}
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">{{ l('StockTakeNo') }}</span>
                                        {{ record.stockTake.stockTakeNo }}
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">{{ l('StockTakeDate') }}</span>
                                        {{ record.stockTake.stockTakeDate  | luxonFormat: "dd-LLL-yyyy"  }}
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">{{ l('Name') }}</span>
                                        {{ record.stockTake.stockTakeName }}
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">{{ l('Remarks') }}</span>
                                        {{ record.stockTake.remarks }}
                                    </td>
                                    <td style="width: 150px" class="text-center">
                                        <span class="p-column-title">{{ l('Status') }}</span>
                                        <span class="badge" [ngClass]="utilsService.getStatusBadgeClass(record.stockTake.status)">
                                            <b>{{ l(status[record.stockTake.status]) }}</b>
                                        </span>
                                    </td>
                                    <td style="width: 150px" class="text-end">
                                        <span class="p-column-title">{{ l('TotalPhysicalQty') }}</span>
                                        {{ record.stockTake.totalPhysicalQty }}
                                    </td>
                                    <td style="width: 150px" class="text-end">
                                        <span class="p-column-title">{{ l('VarianceQty') }}</span>
                                        {{ record.stockTake.totalVarianceQty }}
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">{{ l('CreationTime') }}</span>
                                        {{ record.stockTake.creationTime }}
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>

                        <div class="primeng-no-data" *ngIf="primengTableHelper.totalRecordsCount == 0">
                            {{ l('NoData') }}
                        </div>

                        <div class="primeng-paging-container">
                            <p-paginator
                                [rows]="primengTableHelper.defaultRecordsCountPerPage"
                                #paginator
                                (onPageChange)="getStockTakes($event)"
                                [totalRecords]="primengTableHelper.totalRecordsCount"
                                [rowsPerPageOptions]="primengTableHelper.predefinedRecordsCountPerPage"
                                [showCurrentPageReport]="true"
                                [currentPageReportTemplate]="
                                    'TotalRecordsCount' | localize: primengTableHelper.totalRecordsCount
                                "
                            ></p-paginator>
                        </div>
                    </div>
                    <!--<Primeng-Datatable-End>-->
                </div>
            </div>
        </div>
    </div>
    <createOrEditStockTakeModal
        #createOrEditStockTakeModal
        (modalSave)="getStockTakes()"
    ></createOrEditStockTakeModal>
</div>
